<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Registrar PQR</h5>
        </div>
        <emt-form ref="acount-form" v-bind:itemsFormPqr="itemsFormPqr" v-bind:itemsFormAccount="itemsFormAccount" v-bind:itemsFormAttachment="itemsFormAttachment" v-bind:updateData="update" v-bind:resource="itemResource" v-on:change="changelist" v-bind:typeactivity="typeactivity"></emt-form>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import { Arrays } from '@/helpers'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form-pqr'
import EmtLoading from '@/components/emt-loading'

export default {
    name: 'emt-form-register-pqr',
    data: function () {
        return {
            itemsFormPqr: [
                {
                    'name': 'type',
                    'label': 'Tipo PQR',
                    'placeholder': 'Seleccione tipo PQR',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'unit',
                    'label': 'Unidad',
                    'placeholder': 'Seleccione una unidad',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'dependencies': ['area', 'reason', 'subreason', 'user_assigned']
                }, {
                    'name': 'area',
                    'label': 'Área',
                    'placeholder': 'Seleccione área',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'dependencies': ['reason', 'subreason', 'user_assigned']
                }, {
                    'name': 'reason',
                    'label': 'Motivo',
                    'placeholder': 'Seleccione motivo',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'dependencies': ['subreason']
                }, {
                    'name': 'subreason',
                    'label': 'Submotivo',
                    'placeholder': 'Seleccione submotivo',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'user_assigned',
                    'label': 'Usuario asignado',
                    'placeholder': 'Seleccione usuario',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'channel',
                    'label': 'Canal',
                    'placeholder': 'Seleccione canal',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'company',
                    'label': 'Empresa o filial',
                    'placeholder': 'Seleccione empresa',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'process',
                    'label': 'Referencia',
                    'placeholder': 'Ingrese referencia',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'gender',
                    'label': 'Género',
                    'placeholder': 'Seleccione el género',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'note',
                    'label': 'Descripción',
                    'placeholder': 'Ingrese Descripción de la pqr',
                    'value': null,
                    'maxlength': '5000',
                    'type': 'textarea',
                    'rows': '1',
                    'cols': '1',
                    'errors': []
                }
            ],
            itemsFormAccount: [
                {
                    'name': 'document',
                    'label': 'Documento',
                    'placeholder': 'Ingrese Documento',
                    'maxlength': '15',
                    'value': null,
                    'type': 'text',
                    'errors': []
                },
                {
                    'name': 'name',
                    'label': 'Nombres',
                    'placeholder': 'Ingrese nombres',
                    'maxlength': '50',
                    'value': null,
                    'type': 'text',
                    'errors': []
                },
                {
                    'name': 'surname',
                    'label': 'Apellidos',
                    'placeholder': 'Ingrese Apellidos',
                    'maxlength': '50',
                    'value': null,
                    'type': 'text',
                    'errors': []
                },
                {
                    'name': 'phone_number',
                    'label': 'Teléfono',
                    'placeholder': 'Ingrese número telefónico',
                    'maxlength': '10',
                    'value': null,
                    'type': 'text',
                    'errors': []
                },
                {
                    'name': 'cellphone_number',
                    'label': 'Celular',
                    'placeholder': 'Ingrese Celular',
                    'maxlength': '10',
                    'value': null,
                    'type': 'text',
                    'errors': []
                },
                {
                    'name': 'email',
                    'label': 'Email',
                    'placeholder': 'Ingrese correo electrónico',
                    'maxlength': '50',
                    'value': null,
                    'type': 'text',
                    'errors': []
                }
            ],
            itemsFormAttachment: [
                {
                    'name': 'attachment',
                    'label': 'Adjunto',
                    'placeholder': 'Seleccione Archivo a adjuntar',
                    'value': null,
                    'type': 'file',
                    'extensions': ['PDF', 'XLS', 'XLSX', 'DOC', 'DOCX'],
                    'maximumSize': 20,
                    'errors': []
                }
            ],
            itemResource: [
                {
                    'resourceAccount': '/account/',
                    'resourcePqr': '/pqr/',
                    'resourceAttachment': '/attachment/'
                }
            ],
            update: false,
            typeactivity: 'register'
        }
    },
    methods: {
        /*
        *esta funcion permite consultar y listar los tipos de pqr
        */
        changelist: function (item) {
            var itemSelected = Arrays.getItemBy(item.select_options, 'value', item.value)
            itemSelected = itemSelected === null || itemSelected === undefined ? {id: '', value: ''} : itemSelected
            var callbackObject = {}
            switch (item.name) {
            case 'unit':
                callbackObject = {
                    functions: [this.getArea],
                    arguments: [itemSelected.id]
                }
                Arrays.clearSelect(this.itemsFormPqr, item, callbackObject)
                break
            case 'area':
                callbackObject = {
                    functions: [this.getReason, this.getUserAssigned],
                    arguments: [itemSelected.id, itemSelected.responsible]
                }
                Arrays.clearSelect(this.itemsFormPqr, item, callbackObject)
                break
            case 'reason':
                callbackObject = {
                    functions: [this.getSubreason],
                    arguments: [itemSelected.id]
                }
                Arrays.clearSelect(this.itemsFormPqr, item, callbackObject)
                break
            }
        },
        getType: function () {
            var self = this
            self.$http.get(Config.api + '/pqr_type/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[0].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar las unidades
        */
        getUnits: function () {
            var self = this
            self.$http.get(Config.api + '/unit/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[1].value = ''
                    self.itemsFormPqr[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name,
                        id: response.body[data].id
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar las areas
        */
        getArea: function (value) {
            var self = this
            if ((self.itemsFormPqr[1].value !== undefined && self.itemsFormPqr[1].value !== null) || self.itemsFormPqr[1].value > 0) {
                var id = value
                /*
                var id = self.itemsFormPqr[1].value
                if (typeof (value) !== 'undefined') {
                    id = value
                } else {
                    id = id.split('/')[id.split('/').length - 2]
                }
                */
                self.$http.get(Config.api + '/area/?nopaginate=1&is_active=true&ordering=name&unit=' + id).then(function (response) {
                    self.itemsFormPqr[2].value = ''
                    self.itemsFormPqr[2].select_options = []
                    for (var data in response.body) {
                        self.itemsFormPqr[2].select_options.push({
                            value: response.body[data].url,
                            text: response.body[data].name,
                            id: response.body[data].id,
                            responsible: response.body[data].responsible
                        })
                    }
                }, function (response) {
                    console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
                })
            }
        },
        /*
        *esta funcion permite consultar y listar los Motivos
        */
        getReason: function (value) {
            var self = this
            if ((self.itemsFormPqr[2].value !== undefined && self.itemsFormPqr[2].value !== null) || self.itemsFormPqr[2].value > 0) {
                var id = value
                /*
                var id = self.itemsFormPqr[2].value
                if (typeof (value) !== 'undefined') {
                    id = value
                } else {
                    id = id.split('/')[id.split('/').length - 2]
                }
                */
                self.$http.get(Config.api + '/reason/?nopaginate=1&is_active=true&ordering=name&area=' + id).then(function (response) {
                    self.itemsFormPqr[3].value = ''
                    self.itemsFormPqr[3].select_options = []
                    for (var data in response.body) {
                        self.itemsFormPqr[3].select_options.push({
                            value: response.body[data].url,
                            text: response.body[data].name,
                            id: response.body[data].id
                        })
                    }
                }, function (response) {
                    console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
                })
            }
        },
        /*
        *esta funcion permite consultar y listar los subMotivos
        */
        getSubreason: function (value) {
            var self = this
            if ((self.itemsFormPqr[3].value !== undefined && self.itemsFormPqr[3].value !== null) || self.itemsFormPqr[3].value > 0) {
                var id = value
                self.$http.get(Config.api + '/subreason/?nopaginate=1&is_active=true&ordering=name&reason=' + id).then(function (response) {
                    self.itemsFormPqr[4].value = ''
                    self.itemsFormPqr[4].select_options = []
                    for (var data in response.body) {
                        self.itemsFormPqr[4].select_options.push({
                            value: response.body[data].url,
                            text: response.body[data].name,
                            id: response.body[data].id
                        })
                    }
                }, function (response) {
                    console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
                })
            }
        },
        /*
        *esta funcion permite consultar y listar los subMotivos
        */
        getUserAssigned: function (value) {
            var self = this
            self.$http.get(value).then(function (response) {
                if (response.body.is_active === true) {
                    self.itemsFormPqr[5].value = ''
                    self.itemsFormPqr[5].select_options = [{
                        value: response.body['url'],
                        text: response.body['username']
                    }]
                }
            })
        },
        /*
        *esta funcion permite consultar y listar los subMotivos
        */
        getChannel: function () {
            var self = this
            self.$http.get(Config.api + '/channel/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[6].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los subMotivos
        */
        getCompany: function () {
            var self = this
            self.$http.get(Config.api + '/company/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormPqr[7].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los géneros
        */
        getGender: function () {
            var self = this
            self.$http.get(`${Config.api}/gender/?nopaginate=1&is_active=true&ordering=name`)
                .then(function (response) {
                    for (var data in response.body) {
                        self.itemsFormPqr[9].select_options.push({
                            value: response.body[data].url,
                            text: response.body[data].name
                        })
                    }
                }, function (response) {
                    console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
                })
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getType()
        this.getUnits()
        this.getChannel()
        this.getCompany()
        this.getGender()
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-register-pqr.vue?620aa8ac